/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { ConfigService } from 'src/app/service/config.service';
import { appVersion } from 'src/environments/version';

/**
 * Sentry SDK initializer. Gated on user.email + having an ORG role/group +
 * not tracking-opted-out. Initializes the SDK at most once per session
 * (guarded via `Sentry.getCurrentHub().getClient()`).
 */
@Injectable({
  providedIn: 'root',
})
export class SentryService {
  constructor(private config: ConfigService) {}

  initIfEligible(user: any): void {
    if (!this.isEligible(user)) return;
    if (Sentry.getCurrentHub().getClient()) return;
    try {
      Sentry.init({
        dsn: this.config.appConfig.urlSentry,
        environment:
          this.config.appConfig.environment +
          ' - ' +
          this.config.appConfig.routing.project,
        release: appVersion + ' - ' + this.config.appConfig.version,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [
          'localhost',
          /^https:\/\/yourserver\.io\/api/,
        ],
        replaysSessionSampleRate: this.config.appConfig.production ? 1.0 : 0.1,
        replaysOnErrorSampleRate: 1.0,
      });
    } catch (error) {
      console.error('Error initializing Sentry:', error);
    }
  }

  private isEligible(user: any): boolean {
    if (!user || !user.email) return false;
    if (this.config.appConfig.setup.noTracking) return false;
    if (
      Object.prototype.hasOwnProperty.call(user, 'roles') &&
      (user.roles.includes('NO_TRACKING') ||
        !user.roles.some((role: string) => role.includes('ORG')))
    )
      return false;
    if (
      Object.prototype.hasOwnProperty.call(user, 'groups') &&
      (user.groups.includes('NO_TRACKING') ||
        !user.groups.some((group: string) => group.includes('ORG')))
    )
      return false;
    return true;
  }
}
